import Vue from 'vue'

Vue.use({
    install(Vue) {
        Vue.prototype.$moeda = function(valor) {
            var resultado = valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
            return resultado
        }
    }
})